import { useQuery } from "react-query";
import axios from "axios";

const fetchOrderByNumber = async (orderNumber) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/by-number/${orderNumber}`
  );
  return response.data.order;
};

const useOrderByNumber = (orderNumber, enabled = true) => {
  return useQuery(
    ["orderByNumber", orderNumber],
    () => fetchOrderByNumber(orderNumber),
    { enabled: !!orderNumber && enabled }
  );
};

export default useOrderByNumber;
